<p-dialog [(visible)]="awaitingTerminalPayment" [modal]="true" [closable]="false" [draggable]="false" [resizable]="false" [style]="{width: '380px'}">
    <div style="display:flex; flex-direction:column; align-items:center; gap:20px; padding:32px 24px; text-align:center;">
        <i class="pi pi-spin pi-spinner" style="font-size:3rem; color:#2563eb;"></i>
        <div style="font-size:1.2rem; font-weight:700; color:#111827;">Waiting for Terminal</div>
        <div style="font-size:0.95rem; color:#6b7280;">Please complete the payment on the card reader.</div>
        <button pButton pRipple type="button" label="Cancel Payment" icon="pi pi-times"
            class="p-button p-button-secondary"
            style="min-width:160px;"
            (click)="cancelTerminalPayment()">
        </button>
    </div>
</p-dialog>

<p-dialog [(visible)]="showTerminalBusyDialog" [modal]="true" [closable]="false" [draggable]="false" [resizable]="false" [style]="{width: '420px'}">
    <div style="display:flex; flex-direction:column; align-items:center; gap:20px; padding:28px 24px 8px; text-align:center;">
        <div style="width:60px; height:60px; border-radius:50%; background:#fff7ed; display:flex; align-items:center; justify-content:center;">
            <i class="pi pi-exclamation-triangle" style="font-size:2rem; color:#d97706;"></i>
        </div>
        <div style="font-size:1.2rem; font-weight:700; color:#111827;">Terminal In Use</div>
        <div style="font-size:0.95rem; color:#6b7280; line-height:1.5;">This terminal is currently processing another transaction. Would you like to wait for it to finish, or clear the terminal and retry?</div>
    </div>
    <ng-template pTemplate="footer">
        <div style="display:flex; justify-content:center; gap:10px; padding-bottom:8px;">
            <button pButton pRipple type="button" label="Wait" icon="pi pi-clock"
                class="p-button p-button-secondary p-button-outlined"
                style="min-width:120px;"
                (click)="waitForTerminal()">
            </button>
            <button pButton pRipple type="button" label="Clear Terminal" icon="pi pi-replay"
                class="p-button p-button-danger"
                style="min-width:150px;"
                (click)="clearTerminalAndRetryPayment()">
            </button>
        </div>
    </ng-template>
</p-dialog>

<p-dialog [(visible)]="showPaymentFailedDialog" [modal]="true" [closable]="false" [draggable]="false" [resizable]="false" [style]="{width: '420px'}">
    <div style="display:flex; flex-direction:column; align-items:center; gap:20px; padding:28px 24px 8px; text-align:center;">
        <div style="width:60px; height:60px; border-radius:50%; background:#fef2f2; display:flex; align-items:center; justify-content:center;">
            <i class="pi pi-times-circle" style="font-size:2rem; color:#dc2626;"></i>
        </div>
        <div style="font-size:1.2rem; font-weight:700; color:#111827;">Payment Failed</div>
        <div style="font-size:0.95rem; color:#6b7280; line-height:1.5;">{{paymentFailedMessage}}</div>
    </div>
    <ng-template pTemplate="footer">
        <div style="display:flex; justify-content:center; padding-bottom:8px;">
            <button pButton pRipple type="button" label="Try Again" icon="pi pi-refresh"
                class="p-button p-button-danger"
                style="min-width:140px;"
                (click)="showPaymentFailedDialog=false; paymentButtonLocked=false;">
            </button>
        </div>
    </ng-template>
</p-dialog>

<div *ngIf="showTimer">
    <div class="bookingCountdown" *ngIf="ActualTimeRemaining <= 0">
        Time remaining to complete this booking:  {{ 0 | date:'mm:ss' }}
    </div>

    <div class="bookingCountdown" *ngIf="ActualTimeRemaining > 0">
        Time remaining to complete this booking:  {{ ActualTimeRemaining | date:'mm:ss' }}
    </div>
</div>
<div *ngIf="BookingTimeElasped  && !BookingComplete">
    <div class="clearboth"></div>

    <div style="text-align: center;width: 100%;font-size: 17px;font-weight: bold;padding-top: 5vh;padding-bottom: 50vh;padding-left:20px;padding-right:20px">Your booking session has timed out, please click on the button below to restart.
        <div style="text-align: center; width: 100%; padding-top:40px;" class="StartAgainButton">
            <p-button class="p-button" class="Margin0Padding0" label="Click" icon="pi pi-times" iconPos="left" label="Make a new Booking" (click)="returnHome()"></p-button>
        </div>
    </div>
    
</div>
<div *ngIf="!AccessAllowed && CompletedLoading">
    <h3 style="border: 2px solid;border-radius: 6px;position: absolute;top: 50%;left: 50%;transform: translate(-50%, -50%);padding: 10px;">You don't have access to this function</h3>
</div>
<p-dialog header="Confirmation Preview" [(visible)]="showPrintConfirmations" [style]="{width: '75vw', height: '75vh'}" [baseZIndex]="10000" [modal]="true">
    <div style="margin-top:5px;padding:0px !important">
    <div class="field mb-4 col-12" id="confToPrint">
        <div style="width:100%" [innerHTML]="confHTML | safe: 'html'">
        </div>
    </div>
  </div>
  <ng-template pTemplate="footer" id="noprint" class="noprint">
    <p-button icon="pi pi-print" label="Print" styleClass="p-button p-button-success" (click)="generatePDF()"></p-button>
    &nbsp;
    <p-button icon="pi pi-times" label="Close" styleClass="p-button p-button-success" (click)="showPrintConfirmations = false;"></p-button>
  </ng-template>
</p-dialog>
<p-dialog header="Venue Closing" [(visible)]="showVCWarning" [style]="{width: '50vw', height: '50vh'}" [baseZIndex]="10000" [modal]="true">
    <div class="field mb-4 col-12">
        <div [innerHTML]="VCWarningMessage | safe: 'html'">
        </div>
    </div>

  <ng-template pTemplate="footer">
    <p-button icon="pi pi-check" label="Continue" styleClass="p-button p-button-success" (click)="VCContinue()"></p-button>
  </ng-template>
  
</p-dialog>
<p-dialog header="Deferral Reason" [(visible)]="showDeferReason" [style]="{width: '50vw', height: '50vh'}" [baseZIndex]="10000" [modal]="true">
    <div class="field mb-4 col-12">
        <div>
            <textarea pInputText type="text" style="width:100%; height: 15vw;" [(ngModel)]="deferNotes"></textarea>
        </div>
    </div>

  <ng-template pTemplate="footer">
    <p-button icon="pi pi-pencil" label="Save Note" styleClass="p-button p-button-success" (click)="doReferralNote()"></p-button>
  </ng-template>
  
</p-dialog>
<p-dialog header="Please Note (Scroll to the bottom to agree)" [(visible)]="showWarning" [style]="{width: '50vw', height: '70vh'}" [baseZIndex]="10000" [modal]="true">
    <div class="field mb-4 col-12" style="max-height: 55vh; overflow-y: auto; padding-right: 10px;">
        <div [innerHTML]="WarningMessage | safe: 'html'">
        </div>
        <div style="text-align: center; margin-top: 20px; padding-top: 20px; border-top: 1px solid #ddd;">
            <p-button icon="pi pi-check" label="I agree" styleClass="p-button p-button-success" (click)="WarningContinue()"></p-button>
        </div>
    </div>
    <div style="font-weight: 700;font-size: 1.25em;">
        Please Note (Scroll to the bottom to agree)
    </div>
</p-dialog>
<div *ngIf="!BookingComplete && AccessAllowed && !BookingTimeElasped" style="padding: 1rem;">
    <h3 style="float:left;">{{makeABookingHeader}}</h3>
    <div style="float:right;margin-bottom:10px;">
        <p-button class="p-button" [style]="{'margin': '0px', 'padding' : '0px'}" label="Click" icon="pi pi-times" iconPos="left" label="Start Again" (click)="returnHome()"></p-button>
    </div>
    <div style="clear:both;"></div>
    <div *ngIf="packages">
    <p-accordion>
        <p-accordionTab [(selected)]="dateSelected" [disabled]="dateActive" >
            <p-header style="width:100%">
                <div style="width:100%">
                    <span class="pi pi-calendar" style="margin-right: 10px;" [dateFormat]="dd/mm/yy"></span>{{CalendarHeader}}
                </div>
            </p-header>


        <div class="surface-card p-4 shadow-2 border-round">
        <div class="grid formgrid p-fluid">
            <div class="field mb-4 col-12">
                <label for="ddlPackage" style="float:left; width:100%" class="font-medium">Date</label>
                <div style="max-width: 500px;float:left;">
                    <p-calendar [selectOtherMonths]="true" firstDayOfWeek="1" [(ngModel)]="SelectedDate" dateFormat="dd/mm/yy" [showIcon]="true" (onSelect)="doneDate()"></p-calendar>  
                </div>
                <div style="width:525px; float:left; margin-left:10px;">
                    <button pButton type="button" style="width:120px;" class="p-element p-ripple p-button p-component" (click)="switchToToday()">
                        <span>Today</span>
                    </button>
                    &nbsp;
                    <button pButton type="button" style="width:120px;" class="p-element p-ripple p-button p-component" (click)="switchTomorrow()">
                        <span>Tomorrow</span>
                    </button>
                    &nbsp;
                    <button pButton type="button" style="width:120px;" class="p-element p-ripple p-button p-component" (click)="switchToSaturday()">
                        <span>Saturday</span>
                    </button>
                    &nbsp;
                    <button pButton type="button" style="width:120px;" class="p-element p-ripple p-button p-component" (click)="switchToSunday()">
                        <span>Sunday</span>
                    </button>
                </div>
            </div>
        </div>
        </div>

        </p-accordionTab>

        <p-accordionTab [(selected)]="packageSelected" [disabled]="packageActive">
            <p-header style="width:100%">
                <div style="width:100%">
                    <span class="pi pi-box" style="margin-right: 10px;"></span>{{PackageHeader}}
                </div>
            </p-header>
            <div class="surface-card p-4 shadow-2 border-round">
        <div class="grid formgrid p-fluid">
            Select the Package groups you are interested in below
            <div style="width:100%">
                <span *ngFor="let pg of packageGroups" style="padding: 10px; float: left;">
                    <p-toggleButton [(ngModel)]="checked[pg.packagegroupid]" onLabel="{{pg.packagegroupname}}" offLabel="{{pg.packagegroupname}}" (onChange) = "changedPGSelection(pg)"></p-toggleButton>
                </span>
            </div>

            <div style="clear: both;"></div>

            <div class="surface-card p-4 shadow-2 border-round packageCard" *ngFor="let p of packages">
                <div id="image">
                    <img src="{{p.imageurl}}" style="width:100%">
                </div>
                <div *ngIf="IsDiscountValid(p)" style="width: 100%;background-color: #d30000;color: white;text-align: center;padding: 15px;font-weight: bold;">
                    <span>
                        <img src="assets/images/littlebird.png" style="width: 50px;padding-right: 10px;">
                    </span>
                    <span>
                        You are entitled to an early bird discount
                    </span>
                </div>
                <div style="font-weight: bold; padding: 20px;font-size:larger;">{{ p.name }}</div>
                <div *ngIf="p.repeatable && p.repeatdates?.length > 0" class="srs-card-badge">
                    <span class="pi pi-calendar-plus" style="margin-right:6px;"></span>Repeatable · {{seriesDayCount(p)}} dates · books on its own dates
                </div>
                <div  id="dv{{p.packageId}}collapse" style="padding-left: 20px; padding-right: 20px;height:100px;" [innerHTML]="p.description != null ? (p.description.length < 100 ? p.description : (p.description.substring(0,100)) + '...') : ''">  
                </div>

                <div id="dv{{p.packageId}}expanded" hidden="true" style="padding-left: 20px; padding-right: 20px;height:100%;" [innerHTML]="p.description">  
                </div>

                <div style="height: 120px;">

                </div>

                <div style="position: absolute; bottom: 0px;width:100%;padding: 20px;text-align: right;">
                    <button *ngIf="p.description.length > 99" pButton type="button" value="Show More..." id="dv{{p.packageId}}toggleButton" style="width:178px;" class="p-button-secondary p-button-text" (click)="toggleMore('dv'+p.packageId)">
                        <span>Show More...</span>
                    </button>
                    <div>
                        <p-button label="Book this Package" icon="pi pi-check" (click)="donePackage(p)">
                        </p-button>
                    </div>
                </div>
            </div>

        </div>
        </div>
        </p-accordionTab>

        <p-accordionTab [(selected)]="admissionsSelected" [disabled]="admissionsActive">
            <p-header style="width:100%">
                <div style="width:100%">
                    <span class="pi pi-users" style="margin-right: 10px;"></span> {{AdmissionHeader}}
                </div>
            </p-header>
            <div class="surface-card p-4 shadow-2 border-round">

            <!--<div style="color:red; font-weight:bold;">(FOR TESTING)Total Discounts: {{totalDiscount | currency:CurrencySymbol}}</div> -->

            <div class="grid formgrid p-fluid">
                <div class="field mb-4 col-12">
                <div *ngIf="totalAdmissionInRange">
                    <b>Total Admissions:</b> {{totalAdmissions}}
                    <br/><br/>
                </div>
                <div *ngIf="SelectedPackage != null && !totalAdmissionInRange && totalAdmissions < SelectedPackage.min" style="color: red;">
                    <b>Total Admissions:</b> {{totalAdmissions}} - Please select at least {{SelectedPackage.min}} admissions.
                    <br/><br/>
                </div>
                <div *ngIf="SelectedPackage != null && !totalAdmissionInRange && totalAdmissions > SelectedPackage.max" style="color: red;">
                    <b>Total Admissions:</b> {{totalAdmissions}} - Please select {{SelectedPackage.max}} admissions or less.
                    <br/><br/>
                </div>
                <div class="packageSelection clr" *ngFor="let a of (SelectedAdmissions)">
                    <div *ngIf="a.mustinclude" class="PackageSelectLabel" style="margin-bottom: 8px;">
                        {{a.bookingwizardtext}} *:
                    </div>
                    <div *ngIf="!a.mustinclude" class="PackageSelectLabel" style="margin-bottom: 8px;">
                        {{a.bookingwizardtext}}:
                    </div>

                    <div class="packageSelect" style="max-width: 500px; margin-bottom:20px;">
                    <p-inputNumber [(ngModel)]="SelectedAdmissions[a.index].noofpeople" [disabled]="a.fixed" [id]="'ad'+a.name" [showButtons]="true" max="{{a.max}}" min="{{a.min}}" buttonLayout="horizontal" spinnerMode="horizontal" (onInput)="sumAdmissions(SelectedAdmissions[a.index])" (onBlur)="sumAdmissions(SelectedAdmissions[a.index])"></p-inputNumber>
                    </div>

                    <div style="margin-top: -14px; margin-bottom: 20px;color:red;" *ngIf="!a.countstowardsmin">
                        <span>{{a.message}}</span>
                    </div>
                </div>
                <div style="clear:both;">
                    <button pButton type="button" style="height: 50px; width: 258px;margin-top:20px;" class="p-button p-button" (click)="doneAdmissions()">
                        <span>Select these Admissions</span>
                        <span class="pi pi-chevron-right" style="margin-left:8px;"></span>
                    </button>
                </div>
                <br />
                * denotes that you must have at least one of these.
                </div>
            </div>
        </div>

        </p-accordionTab>

        <p-accordionTab *ngIf="includesComplexResources" [(selected)]="partyroomsSelected" [disabled]="partyroomsActive">
            <p-header style="width:100%">
                <div style="width:100%">
                    <span class="pi pi-sitemap" style="margin-right: 10px;"></span> {{SelResourceHeader}}
                </div>
            </p-header>
            <div class="surface-card p-4 shadow-2 border-round">

                <div class="grid formgrid p-fluid">
                    <div class="field mb-4 col-12">
                        <div class="packageSelection clr" *ngFor="let a of (SelectedResources)">
                            <div *ngIf="a.mode == 'COMPLEX' && a.selectionmode != 'SYSTEMANY' && a.selectionmode != 'SYSTEMLIST' && a.selectionmode != ''"  class="PackageSelectLabel" style="margin-bottom: 8px;">
                                <div style="margin-bottom:10px;" *ngIf="!a.optional"><b>Please select one of these {{a.name}}:</b></div>
                                
                                <div style="margin-bottom:10px;" *ngIf="a.optional">
                                    <div style="width:55px; float:left;"><p-inputSwitch [(ngModel)]="SelectedSeletableResourceBool[a.orderindex]"></p-inputSwitch></div>
                                    <div *ngIf="!a.isconstructed == true" style="width:400px;float:left"><b>Would you like a {{a.name}}?</b></div>
                                    <div *ngIf="a.isconstructed == true" style="width:400px;float:left"><b>Would you like to choose a {{a.name}}?</b></div>
                                    <div style="clear:both;"></div>
                                </div>
    
                                <div *ngIf="a.optional && SelectedSeletableResourceBool[a.orderindex] && a.isconstructed == true" >
                                    <div class="packageSelection clr" *ngFor="let r of (a.resources)">
                                        <p-radioButton *ngIf="!r.disabled" style="margin-top:5px; margin-bottom: 5px; margin-left: 10px" name="{{a.groupname}}" value="{{r.id}}" label="{{r.name}}" [(ngModel)]="SelectedSeletableResource[a.orderindex]"></p-radioButton>
                                    </div>
                                    <div style="clear:both;"></div>
                                </div>

                                <div *ngIf="!a.optional" >
                                    <div class="packageSelection clr" *ngFor="let r of (a.resources)">
                                        <p-radioButton *ngIf="!r.disabled" style="margin-top:5px; margin-bottom: 5px; margin-left: 10px" name="{{a.groupname}}" value="{{r.id}}" label="{{r.name}}" [(ngModel)]="SelectedSeletableResource[a.orderindex]"></p-radioButton>
                                    </div>
                                </div>
                                <div *ngIf="!validselection[a.orderindex] && validselection[a.orderindex] != null" class="text-danger" Style="margin-left:10px;">
                                    <div style="clear:both;"></div>
                                    <span class="pi pi-exclamation-triangle" style="margin-right:5px;"></span>You must select from the list above.
                                </div>

                                <div *ngIf="a.quantityselector == 'CUSTOM' && a.optional" Style="margin-left:10px;">
                                    <div class="PackageSelectLabel" style="margin-bottom: 8px;">
                                        How many of the above resources would you like?
                                    </div>
                                    <div class="packageSelect" style="max-width: 500px; margin-bottom:20px;">
                                    <p-inputNumber [(ngModel)]="a.quantity" [showButtons]="true" max="100" min="1" buttonLayout="horizontal" spinnerMode="horizontal"></p-inputNumber>
                                    </div>
                                </div>

                                <hr>
                            </div>

                            <div *ngIf="a.mode == 'COMPLEX'
                             && a.optional && a.selectionmode == ''"  class="PackageSelectLabel" style="margin-bottom: 8px;">
                                <div style="margin-bottom:10px;" *ngIf="!a.optional"><b>Please select one of these {{a.name}}:</b></div>
                                
                                <div style="margin-bottom:10px;" *ngIf="a.optional">
                                    <div style="width:55px; float:left;"><p-inputSwitch [(ngModel)]="SelectedSeletableResourceBool[a.orderindex]"></p-inputSwitch></div>
                                    <div *ngIf="!a.isconstructed == true" style="width:400px;float:left"><b>Would you like a {{a.name}}?</b></div>
                                    <div *ngIf="a.isconstructed == true" style="width:400px;float:left"><b>Would you like to choose a {{a.name}}?</b></div>
                                    <div style="clear:both;"></div>
                                </div>

                                <div *ngIf="SelectedSeletableResourceBool[a.orderindex] && a.quantityselector == 'CUSTOM'" Style="margin-left:10px;">
                                    <div class="PackageSelectLabel" style="margin-bottom: 8px;">
                                        How many of the above resource would you like?
                                    </div>
                                    <div class="packageSelect" style="max-width: 500px; margin-bottom:20px;">
                                    <p-inputNumber [(ngModel)]="a.quantity" [showButtons]="true" max="100" min="1" buttonLayout="horizontal" spinnerMode="horizontal"></p-inputNumber>
                                    </div>
                                </div>

                                <hr>
                            </div>
                        </div>

                    <div style="clear:both;">
                        <button pButton type="button" style="height: 50px; width: 258px;margin-top:20px;" class="p-button p-button" (click)="donePartyRooms()">
                            <span>Add this Selection</span>
                            <span class="pi pi-chevron-right" style="margin-left:8px;"></span>
                        </button>
                    </div>
                    </div>
                </div>
            </div>
        </p-accordionTab>

        <p-accordionTab [(selected)]="timeSelected" [disabled]="timeActive">
            <p-header style="width:100%">
                <div style="width:100%">
                    <span class="pi pi-clock" style="margin-right: 10px;"></span> {{TimeHeader}}
                </div>
            </p-header>

            <!-- Repeatable package: every upcoming date at once, instead of one date's times. -->
            <div *ngIf="isRepeatable" class="surface-card p-4 shadow-2 border-round srs">
                <div *ngIf="seriesLoading" class="srs-muted">Checking availability for every date…</div>

                <ng-container *ngIf="!seriesLoading">
                    <div *ngIf="seriesDates.length == 0" class="srs-muted">All of this package's dates have passed.</div>

                    <ng-container *ngIf="seriesDates.length > 0">
                        <div class="srs-dates-line">
                            <span class="srs-dates-label">{{seriesDates.length}} {{seriesDates.length == 1 ? 'date' : 'dates'}}</span>
                            <span class="srs-datepills">
                                <span *ngFor="let item of seriesDates" class="srs-datepill" [class.srs-datepill--full]="item.times.length == 0" [pTooltip]="item.times.length == 0 ? (item.reason || 'No times left on this date') : ''" tooltipPosition="top">{{item.date | date:'EEE d MMM' : 'UTC'}}</span>
                            </span>
                        </div>

                        <!-- Fixed blocks: a card per block, taken whole. The free-pick choices
                             below are not offered on a block package. -->
                        <div *ngIf="isBlockPackage" class="srs-blocks">
                            <button type="button" *ngFor="let block of seriesBlocks"
                                    class="srs-choice srs-block"
                                    [class.srs-choice--on]="seriesChosenBlockId == block.blockid"
                                    [class.srs-block--off]="!block.available"
                                    [disabled]="!block.available"
                                    (click)="chooseSeriesBlock(block)">
                                <span class="srs-choice-name">{{block.name}}</span>
                                <span class="srs-block-range">{{block.rangeText}} &middot; {{block.sessions}} {{block.sessions == 1 ? 'session' : 'sessions'}}</span>
                                <span class="srs-choice-price">{{seriesBlockPrice(block) | currency:CurrencySymbol}} <small>for {{seriesPeople}} {{seriesPeople == 1 ? 'person' : 'people'}}</small></span>
                                <span *ngIf="block.available" class="srs-choice-note">Every session is free. The whole run is booked together.</span>
                                <span *ngIf="!block.available" class="srs-choice-note srs-block-why">{{seriesBlockReason(block)}}</span>
                            </button>
                        </div>

                        <div *ngIf="isBlockPackage && seriesBlocks.length == 0" class="srs-muted">
                            This package has no runs set up yet.
                        </div>

                        <div *ngIf="!isBlockPackage" class="srs-choices">
                            <button type="button" class="srs-choice" [class.srs-choice--on]="seriesMode == 'ALL'" [disabled]="!seriesAllAllowed" (click)="chooseSeriesMode('ALL')">
                                <span class="srs-choice-name">All {{seriesDates.length}} dates</span>
                                <span class="srs-choice-price">{{seriesAllDatesPrice | currency:CurrencySymbol}} <small>for {{seriesPeople}} {{seriesPeople == 1 ? 'person' : 'people'}}</small></span>
                                <span *ngIf="seriesAllAllowed" class="srs-choice-note">One time for every date. Any date where it's full gets another time.</span>
                                <span *ngIf="!seriesAllAllowed" class="srs-choice-note">Not available: the first date has already passed.</span>
                            </button>
                            <button type="button" class="srs-choice" [class.srs-choice--on]="seriesMode == 'SOME'" (click)="chooseSeriesMode('SOME')">
                                <span class="srs-choice-name">Choose dates</span>
                                <span class="srs-choice-price">{{seriesPerDatePrice | currency:CurrencySymbol}} <small>per date, for {{seriesPeople}} {{seriesPeople == 1 ? 'person' : 'people'}}</small></span>
                                <span class="srs-choice-note">Tick the dates wanted and pick a time on each.</span>
                            </button>
                        </div>

                        <!-- All dates -->
                        <ng-container *ngIf="!isBlockPackage && seriesMode == 'ALL'">
                            <h4 class="srs-h">Pick a time for all {{seriesDates.length}} dates</h4>

                            <div *ngIf="seriesFullDates.length > 0" class="srs-warn">
                                <span>
                                    <span *ngIf="seriesFullDates.length == seriesDates.length">None of the {{seriesDates.length}} dates has any times left, so they can't be booked together.</span>
                                    <span *ngIf="seriesFullDates.length < seriesDates.length">{{seriesFullDates.length}} of the {{seriesDates.length}} dates {{seriesFullDates.length == 1 ? 'has' : 'have'}} no times left, so they can't all be booked together.</span>
                                    <span class="srs-warn-why">Hover a greyed date above to see why.</span>
                                </span>
                                <button *ngIf="seriesFullDates.length < seriesDates.length" pButton type="button" class="p-button p-button-sm p-button-outlined w-auto" (click)="switchSeriesToSome()">Switch to Choose dates</button>
                            </div>

                            <div class="srs-times">
                                <button type="button" *ngFor="let option of seriesTimeOptions; trackBy: seriesTrackTime" class="srs-time" [class.srs-time--on]="seriesPreferredTime == option.time" (click)="chooseSeriesPreferredTime(option.time)">
                                    <b>{{option.time}}</b>
                                    <span [class.srs-all]="option.count == seriesDates.length">{{option.count == seriesDates.length ? 'Every date' : option.count + ' of ' + seriesDates.length + ' dates'}}</span>
                                </button>
                            </div>

                            <div *ngIf="seriesPreferredTime != ''" class="srs-weeks">
                                <div *ngFor="let item of seriesDates" class="srs-week" [class.srs-week--needs]="item.chosen == null">
                                    <span class="srs-week-date">{{item.date | date:'EEE d MMM yyyy' : 'UTC'}}</span>
                                    <span *ngIf="item.held != null" class="srs-held">Held · {{item.chosen?.timeString}}</span>
                                    <span *ngIf="item.held == null && item.chosen != null" class="srs-week-time" [class.srs-week-time--changed]="item.chosen.timeString != seriesPreferredTime">
                                        <span class="pi pi-check" style="margin-right:4px;"></span>{{item.chosen.timeString}}{{item.chosen.timeString != seriesPreferredTime ? ' · changed' : ''}}
                                    </span>
                                    <span *ngIf="item.chosen == null && item.times.length > 0" class="srs-week-msg">{{item.failed ? 'That time was taken meanwhile' : seriesPreferredTime + ' is full'}}, choose a time</span>
                                    <span *ngIf="item.times.length == 0" class="srs-week-msg">{{item.reason || 'No times left on this date'}}</span>
                                    <div *ngIf="item.held == null && item.times.length > 0 && (item.chosen == null || item.chosen.timeString != seriesPreferredTime)" class="srs-chips">
                                        <button type="button" *ngFor="let slot of seriesAlternatives(item)" class="srs-chip" [class.srs-chip--on]="item.chosen == slot" (click)="chooseSeriesTime(item, slot)">{{slot.timeString}}</button>
                                    </div>
                                </div>
                            </div>
                        </ng-container>

                        <!-- Choose dates -->
                        <ng-container *ngIf="!isBlockPackage && seriesMode == 'SOME'">
                            <h4 class="srs-h">Choose dates</h4>

                            <div *ngIf="seriesMaxDates > 0 || seriesRunPriceFrom > 0" class="srs-muted" style="margin-bottom:10px;">
                                <span *ngIf="seriesMaxDates > 0">Up to {{seriesMaxDates}} dates ({{seriesTickedCount}} chosen).</span>
                                <span *ngIf="seriesRunPriceFrom > 0">
                                    {{seriesRunPriceFrom}} or more are charged at the run price of {{seriesAllDatesPrice | currency:CurrencySymbol}}.
                                </span>
                            </div>

                            <div *ngIf="seriesOnRunPrice" class="srs-info">
                                <span>{{seriesTickedCount}} dates chosen, so this is the run price - {{seriesAllDatesPrice | currency:CurrencySymbol}}.</span>
                            </div>

                            <div *ngIf="seriesAtMaxDates" class="srs-warn">
                                <span>That is the most this package allows. Untick a date to choose a different one.</span>
                            </div>

                            <div *ngIf="seriesAllTicked && seriesAllAllowed" class="srs-info">
                                <span>Every date is ticked. All {{seriesDates.length}} dates cost {{seriesAllDatesPrice | currency:CurrencySymbol}}.</span>
                                <button pButton type="button" class="p-button p-button-sm p-button-outlined w-auto" (click)="switchSeriesToAll()">Use the all-dates price</button>
                            </div>

                            <div class="srs-weeks">
                                <div *ngFor="let item of seriesDates" class="srs-week" [class.srs-week--off]="!item.ticked" [class.srs-week--needs]="item.ticked && item.chosen == null">
                                    <span class="srs-week-date srs-week-pick">
                                        <button type="button" class="srs-tick" [class.srs-tick--on]="item.ticked" [disabled]="item.times.length == 0 || item.held != null || (!item.ticked && seriesAtMaxDates)" [attr.aria-pressed]="item.ticked" [attr.aria-label]="'Book ' + (item.date | date:'EEE d MMM yyyy' : 'UTC')" (click)="toggleSeriesDate(item)">
                                            <span *ngIf="item.ticked" class="pi pi-check"></span>
                                        </button>
                                        {{item.date | date:'EEE d MMM yyyy' : 'UTC'}}
                                    </span>
                                    <span *ngIf="item.times.length == 0" class="srs-muted">Fully booked</span>
                                    <span *ngIf="item.held != null" class="srs-held">Held · {{item.chosen?.timeString}}</span>
                                    <span *ngIf="item.held == null && item.ticked && item.chosen != null" class="srs-week-time"><span class="pi pi-check" style="margin-right:4px;"></span>{{item.chosen.timeString}}</span>
                                    <span *ngIf="item.ticked && item.chosen == null" class="srs-week-msg">{{item.failed ? 'That time was taken meanwhile, choose another' : 'Choose a time'}}</span>
                                    <div *ngIf="item.ticked && item.held == null && item.times.length > 0" class="srs-chips">
                                        <button type="button" *ngFor="let slot of item.times" class="srs-chip" [class.srs-chip--on]="item.chosen == slot" (click)="chooseSeriesTime(item, slot)">{{slot.timeString}}</button>
                                    </div>
                                </div>
                            </div>
                        </ng-container>

                        <!-- The chosen block. Every date is in, so there is no ticking - only a
                             time to settle on each, which opens on the earliest free one. -->
                        <ng-container *ngIf="isBlockPackage && seriesMode == 'BLOCK' && seriesChosenBlock != null">
                            <h4 class="srs-h">{{seriesChosenBlock.name}} &middot; all {{seriesChosenBlock.sessions}} sessions</h4>

                            <div class="srs-weeks">
                                <div *ngFor="let item of seriesChosenBlock.dates" class="srs-week" [class.srs-week--needs]="item.chosen == null">
                                    <span class="srs-week-date">{{item.date | date:'EEE d MMM yyyy' : 'UTC'}}</span>
                                    <span *ngIf="item.held != null" class="srs-held">Held &middot; {{item.chosen?.timeString}}</span>
                                    <span *ngIf="item.held == null && item.chosen != null" class="srs-week-time"><span class="pi pi-check" style="margin-right:4px;"></span>{{item.chosen.timeString}}</span>
                                    <span *ngIf="item.chosen == null" class="srs-week-msg">Choose a time</span>
                                    <div *ngIf="item.held == null && item.times.length > 1" class="srs-chips">
                                        <button type="button" *ngFor="let slot of item.times" class="srs-chip" [class.srs-chip--on]="item.chosen == slot" (click)="chooseSeriesTime(item, slot)">{{slot.timeString}}</button>
                                    </div>
                                </div>
                            </div>
                        </ng-container>

                        <div *ngIf="seriesMode != ''" class="srs-footer">
                            <div class="srs-total">
                                <span>{{seriesChosenDates.length}} {{seriesChosenDates.length == 1 ? 'date' : 'dates'}} · {{seriesPeople}} {{seriesPeople == 1 ? 'person' : 'people'}}</span>
                                <b>{{seriesEstimate | currency:CurrencySymbol}}</b>
                            </div>
                            <span class="srs-muted">An estimate. The price is worked out when the dates are held.</span>
                            <span *ngIf="seriesUnresolved > 0" class="srs-attention">{{seriesUnresolved}} {{seriesUnresolved == 1 ? 'date still needs' : 'dates still need'}} a time</span>
                            <div>
                                <button pButton type="button" style="height: 50px; width: 258px;" class="p-button" [disabled]="!seriesCanHold" (click)="holdSeriesDates()">
                                    <span class="pi pi-lock" style="margin-right:8px;"></span>
                                    <span>Hold these dates</span>
                                </button>
                            </div>
                        </div>
                    </ng-container>
                </ng-container>
            </div>

            <ng-container *ngIf="!isRepeatable">
            <div class="surface-card p-4 shadow-2 border-round">  
                
            <div *ngIf="!disgnosticsMode">    
                <div *ngFor="let st of (startTimesFiltered)" class="times">
                    <!--<p-button style="margin:0px;" class="p-button" label="Click" icon="pi pi-clock" iconPos="left" label="Move booking to {{ st.time | date:'HH:mm' : 'UTC' }}" (click)="bookSlot(st)"></p-button>-->
                    <button style="padding: 25px 43px 25px 43px;font-weight:bold;" class="p-button" (click)="bookSlot(st)">
                        <span class="pi pi-clock" style="margin-right:8px;"></span>
                        {{ st.time | date:'HH:mm' : 'UTC'}}
                    </button>
                </div>
            </div>

            <div *ngIf="disgnosticsMode">  
                <div *ngFor="let st of (startTimes)">
                    <!--<input type=button class='bookButtonND' value="{{ st.time | date:'HH:mm' }}" id='btnbook' (click)="bookSlot(st.time)">-->
                    <div style="width:100%; margin-bottom: 10px;">
                       
                        <div *ngIf='st.primaryResource == true && st.timeAvailable == true' class="times">
                            <div style="float:left;">
                                <button style="padding: 25px 43px 25px 43px;;font-weight:bold;" class="p-button" (click)="bookSlot(st)">
                                    <span class="pi pi-clock" style="margin-right:8px;"></span>
                                    {{ st.time | date:'HH:mm' : 'UTC'}}
                                </button>
                            </div>
                        </div>

                        <div *ngIf='st.primaryResource == true && st.timeAvailable == false' style="width:100%;">
                            <div style="float:left;">
                                <!--<p-button style="margin:0px;" class="p-button" label="Click" disabled="true" icon="pi pi-clock" iconPos="left" label="{{ st.time | date:'HH:mm' : 'UTC' }}"></p-button>-->
                                <button style="padding: 25px 43px 25px 43px;;font-weight:bold;color:#bbbbbb" class="p-button" [disabled]="true">
                                    <span class="pi pi-clock" style="margin-right:8px;"></span>
                                    {{ st.time | date:'HH:mm' : 'UTC'}}
                                </button>
                            </div>
                        </div>

                        <div  *ngIf='st.primaryResource == true' style="font-size: 17px;margin-top: 25px;width: 200px;float: left;margin-left: 20px;">Quantity Remaining: {{ st.quantityRemaining }}</div>
                        
                        <div *ngIf='st.primaryResource == true && st.reason != ""' style="font-size: 17px;margin-top: 15px;width: 400px;float: left;margin-left: 20px;background-color: pink;padding:10px;border-radius:40px;text-align:center;">Reason: {{ st.reason }}</div>
                        <div *ngIf='st.primaryResource == true && st.reason == ""' style="font-size: 17px;margin-top: 15px;width: 400px;float: left;margin-left: 20px;background-color: #91ff91;padding:10px;border-radius:40px;text-align:center;">No issues found</div>
                    
                    </div>
                    <div style="clear:both;"></div>
                </div>
            </div>
            
            <div style="clear: both; height:75px;"></div>

            <div *ngIf="startTimesFiltered === null || startTimesFiltered === undefined || startTimesFiltered.length == 0" style="margin-top: -50px; margin-bottom: 68px;">{{NoAvailabilityMessage}}</div>
        </div>
            </ng-container>
        </p-accordionTab>

        <p-accordionTab *ngIf="showUpgradesScreen == true"  [(selected)]="upgradeSelected" [disabled]="upgradeActive">
            <p-header style="width:100%">
                <div style="width:100%">
                    <span class="pi pi-arrow-up" style="margin-right: 10px;"></span> {{UpgradeHeader}}
                </div>
            </p-header>
            <div class="surface-card p-4 shadow-2 border-round">

            <div class="grid formgrid p-fluid">
                <div class="field mb-4 col-12">
                    <div class="surface-card p-4 shadow-2 border-round packageCard" *ngFor="let pu of availablePackageUpgrades">
                        <div id="image">
                            <img src="{{pu.upgrade.imageurl}}" style="width:100%">
                        </div>

                        <div style="font-weight: bold; padding: 20px;font-size:larger;">{{ pu.name }}</div>
                        <div  id="dv{{pu.packageupgradeid}}collapse" style="padding-left: 20px; padding-right: 20px;height:100px;" [innerHTML]="pu.upgrade.description != null ? (pu.upgrade.description.length < 100 ? pu.upgrade.description : (pu.upgrade.description.substring(0,100)) + '...') : ''">  
                        </div>
        
                        <div id="dv{{pu.packageId}}expanded" hidden="true" style="padding-left: 20px; padding-right: 20px;height:100%;" [innerHTML]="pu.upgrade.description">  
                        </div>
        
                        <div style="height: 120px;">
        
                        </div>
        
                        <div style="position: absolute; bottom: 0px;width:100%;padding: 20px;text-align: right;">
                            <button *ngIf="pu.upgrade.description.length > 99" pButton type="button" value="Show More..." id="dv{{pu.packageupgradeid}}toggleButton" style="width:178px;" class="p-button-secondary p-button-text" (click)="toggleMore('dv'+pu.packageupgradeid)">
                                <span>Show More...</span>
                            </button>
                            <div>
                                <p-button label="Add this Upgrade" icon="pi pi-check" (click)="doneUpgrade(pu)">
                                </p-button>
                            </div>
                        </div>
                    </div>

                    <div style="clear:both;"></div>
                    <button pButton type="button" style="height: 50px; width: 258px;margin-top:20px;margin-left:15px;" class="p-button p-button" (click)="skipUpgrade(pu)">
                        <span class="pi pi-thumbs-down" style="margin-right:8px;"></span>
                        <span>Skip Upgrades</span>
                    </button>


                </div>

            </div>
        </div>

        </p-accordionTab>

        <!--Admissions Based Upgrades-->

        <p-accordionTab *ngIf="showOptionalUpgradesScreen == true" [(selected)]="optionalUpgradeSelected" [disabled]="optionalUpgradeActive">
            <p-header style="width:100%">
                <div style="width:100%">
                    <span class="pi pi-arrow-up" style="margin-right: 10px;"></span> {{OptionalUpgradeHeader}}
                </div>
            </p-header>
            <div class="surface-card p-4 shadow-2 border-round">

            <div class="grid formgrid p-fluid">
                <div class="field mb-4 col-12">
                    <div class="surface-card p-4 shadow-2 border-round packageCard" *ngFor="let pu of availablePackageOptionalUpgrades">
                        <div id="image">
                            <img src="{{pu.upgrade.imageurl}}" style="width:100%">
                        </div>

                        <div style="font-weight: bold; padding: 20px;font-size:larger;width:100%;float:left;">{{ pu.name }}</div>
                        <div>
                            <div id="dv{{pu.packageupgradeid}}collapse" style="padding-left: 20px; padding-right: 20px;height:100%;;width:100%;float:left;" [innerHTML]="pu.upgrade.description != null ? (pu.upgrade.description.length < 100 ? pu.upgrade.description : (pu.upgrade.description.substring(0,100)) + '...') : ''">  
                            </div>
            
                            <div id="dv{{pu.packageupgradeid}}expanded" hidden="true" style="padding-left: 20px; padding-right: 20px;height:100%;;width:100%;float:left;" [innerHTML]="pu.upgrade.description">  
                            </div>
                        </div>
                        <div style="clear:both"></div>
        
                        <div style="float:left;width:100%;padding: 20px;text-align: right;margin-bottom:20px;">
                            <button *ngIf="pu.upgrade.description.length > 99" pButton type="button" value="Show More..." id="dv{{pu.packageupgradeid}}toggleButton" style="width:178px;" class="p-button-secondary p-button-text" (click)="toggleMore('dv'+pu.packageupgradeid)">
                                <span>Show More...</span>
                            </button>

                            <div style="text-align: left;float:left;width:100%;">
                                <label for="qty{{pu.packageupgradeid}}" class="font-medium" style="margin-bottom:10px;">Quantity required:</label>
                                <p-dropdown [style]="{'width': '100%' }" optionLabel="name" optionValue="value" [options]="pu | getQuantityOptions:getOptionalUpgradeQuantities" [(ngModel)]="pu.quantity" placeholder="Select Quantity" id="qty{{pu.packageupgradeid}}"></p-dropdown>
                            </div>  
                        </div>
                    </div>

                    <div style="clear:both;"></div>
                    <button pButton type="button" style="height: 50px; width: 258px;margin-top:20px;margin-left:15px;" class="p-button p-button" (click)="doneOptionalUpgrade()">
                        <span>Select These Add-Ons</span>
                        <span class="pi pi-chevron-right" style="margin-left:8px;"></span>
                    </button>
                    <button pButton type="button" style="height: 50px; width: 258px;margin-top:20px;margin-left:15px;" class="p-button p-button" (click)="skipOptionalUpgrade(pu)">
                        <span class="pi pi-thumbs-down" style="margin-right:8px;"></span>
                        <span>Skip Add-Ons</span>
                    </button>


                </div>

            </div>
        </div>

        </p-accordionTab>


        <!----------------------------->

        <p-accordionTab *ngIf="SelectedPackage && SelectedPackage.questionnaire" [(selected)]="bookingQuestionsSelected" [disabled]="bookingQuestionsActive">
            <p-header style="width:100%">
                <div style="width:100%">
                    <span class="pi pi-question-circle" style="margin-right: 10px;"></span> Booking Questions
                </div>
            </p-header>
            <div class="surface-card p-4 shadow-2 border-round">
                <div class="grid formgrid p-fluid">
                    <div *ngFor="let bq of SelectedPackage.questionnaire.bookingquestions" class="field mb-4 col-12">
                        <div *ngIf="bq.questiontype=='FREETEXT' && bq.answers != null">
                            <label for="bq{{bq.id}}" class="font-medium">{{bq.questiontext}}</label>
                            <input id="bq{{bq.id}}" type="text" [(ngModel)]="bq.answers.freetextanswer" pInputText [ngClass]="{'ng-invalid ng-dirty': !mustanswerfreetext[bq.listorder]}">
                            <div *ngIf="!mustanswerfreetext[bq.listorder]" class="text-danger" Style="margin-left:10px;margin-top:10px;"><span class="pi pi-exclamation-triangle" style="margin-right:5px;"></span>You must answer this question.</div>
                        </div>
                        
                        <div *ngIf="bq.questiontype=='BIRTHDAY' && bq.answers != null">
                            <div style="width:100%; float:left;"><label for="bq{{bq.id}}" class="font-medium">{{bq.questiontext}}</label></div>                      
                            <div *ngFor="let ibq of bq.answers.birthdayanswers" style="width: 100%;">
                                <div style="width:100%">
                                    <div>
                                        <div style="min-width: 300px; width:31%; float:left; margin-right:1%;margin-bottom:10px;margin-top: 5px;">
                                            Name<br>
                                            <input id="bqname{{bq.id}}_{{ibq.id}}" type="text" [(ngModel)]="ibq.name" pInputText [ngClass]="{'ng-invalid ng-dirty': !mustanswerbirthdays[bq.listorder] && (ibq.name == '' || ibq.name == null)}">
                                        </div>

                                        <div *ngIf="bq.showage" style="min-width: 300px; width:31%; float:left; margin-right:1%;margin-bottom:10px;margin-top: 5px;">
                                            Age<br>
                                            <!-- <p-inputNumber [showButtons]="true" [(ngModel)]="ibq.age"  buttonLayout="horizontal" spinnerMode="horizontal"></p-inputNumber> -->
                                            <p-dropdown [showClear]="true" [options]="ageOptionsFor(bq)" [(ngModel)]="ibq.age" placeholder="Select age" optionLabel="name" optionValue="value" [ngClass]="{'ng-invalid ng-dirty': !mustanswerbirthdays[bq.listorder] && (ibq.age == '' || ibq.age == null)}"></p-dropdown>
                                        </div>

                                        <div *ngIf="bq.showdob" style="min-width: 300px; width:31%; float:left;margin-bottom:10px;margin-top: 5px;">
                                            Date of Birth<br>
                                            <p-dropdown [style]="{'float': 'left', 'width': '96px' }" optionLabel="name" optionValue="value" [options]="caldays" [(ngModel)]="ibq.dobday" placeholder="--" [ngClass]="{'ng-invalid ng-dirty': !mustanswerbirthdays[bq.listorder] && (ibq.dobday == null || ibq.dobmonth == null || ibq.dobyear == null)}"></p-dropdown>
                                            <span style="float:left;margin-top: 12px;">&nbsp;/&nbsp;</span>
                                            <p-dropdown [style]="{'float': 'left', 'width': '96px' }"  optionLabel="name" optionValue="value" [options]="calmonths" [(ngModel)]="ibq.dobmonth" placeholder="--" [ngClass]="{'ng-invalid ng-dirty': !mustanswerbirthdays[bq.listorder] && (ibq.dobday == null || ibq.dobmonth == null || ibq.dobyear == null)}"></p-dropdown>
                                            <span style="float:left;margin-top: 12px;">&nbsp;/&nbsp;</span>
                                            <p-dropdown [style]="{'float': 'left', 'width': '115px' }"  optionLabel="name" optionValue="value" [options]="calyears" [(ngModel)]="ibq.dobyear" placeholder="----" [ngClass]="{'ng-invalid ng-dirty': !mustanswerbirthdays[bq.listorder] && (ibq.dobday == null || ibq.dobmonth == null || ibq.dobyear == null)}"></p-dropdown>
                                        </div>

                                        <div *ngIf="bq.answers.birthdayanswers.length > 1 && !bq.linkedtoparticipants" style="float:left; margin-top: 24px; margin-left: 10px;">
                                            <button pButton type="button" style="height: 50px; width: 58px;" class="p-button-danger p-button" (click)="deleteBirthdayRow(bq, ibq.id)">
                                                <span class="pi pi-trash"></span>
                                            </button>
                                        </div>
                                    </div>
                                    <div style="clear:both;"></div>
                                    <div *ngIf="!DOBIsValid" class="text-danger" Style="margin-left:10px;margin-top:10px;"><span class="pi pi-exclamation-triangle" style="margin-right:5px;"></span>Please enter a valid date.</div>

                                    <div style="width:100%">
                                        <div *ngIf="bq.showgender" style="min-width: 300px; width:48%; float:left; margin-right:1%;margin-bottom:10px;margin-top: 5px;">
                                            Gender<br>
                                            <p-selectButton id="bqgender{{bq.id}}_{{ibq.id}}" [style]="{'min-width' : '300px'}" [options]="stateGenderOptions" [(ngModel)]="ibq.gender" ></p-selectButton>
                                        </div>

                                        <div *ngIf="bq.showinterests" style="min-width: 300px; width:48%; float:left; margin-right:1%;margin-bottom:10px;margin-top: 5px;">
                                            Interests<br>
                                            <input id="bqint{{bq.id}}_{{ibq.id}}" type="text" [(ngModel)]="ibq.interests" pInputText [ngClass]="{'ng-invalid ng-dirty': !mustanswerbirthdays[bq.listorder] && (ibq.interests == '' || ibq.interests == null)}">
                                        </div>
                                    </div>
                                </div>
                               
                                <div style="clear:both;"></div>
                            </div>
                            <div style="clear:both;"></div>
                            <div style="width:100%" *ngIf="!bq.linkedtoparticipants">
                                <button pButton type="button" style="height: 50px; width: 225px;margin-top:20px;" class="p-button p-button" (click)="addBirthdayRow(bq)">
                                    <span>Add another</span>
                                    <span class="pi pi-chevron-right" style="margin-left:8px;"></span>
                                </button>
                            </div>
                             <div *ngIf="!mustanswerbirthdays[bq.listorder]" class="text-danger" Style="margin-left:10px;margin-top:10px;"><span class="pi pi-exclamation-triangle" style="margin-right:5px;"></span>You must provide all details.</div>
                        </div>
                        
                        <div *ngIf="bq.questiontype=='ALLERGY' && bq.answers != null">
                            <label for="bq{{bq.id}}" class="font-medium">{{bq.questiontext}}</label>
                            <p-selectButton id="allergy" [style]="{'width': '100%', 'max-width' : '230px'}" [options]="stateOptionAllergy" [(ngModel)]="bq.answers.allergyanswer.allergypresent" [ngClass]="{'ng-invalid ng-dirty': bq.answers.allergyanswer.allergypresent == null}"></p-selectButton>

                            <!--<p-dropdown [options]="allergyOptions" [(ngModel)]="bq.answers.allergyanswer.allergypresent" placeholder="Choose an answer" [showClear]="true" optionLabel="name" optionValue="value"></p-dropdown>-->

                            <div *ngIf="bq.answers.allergyanswer.allergypresent == null" class="text-danger" Style="margin-left:10px;margin-top:10px;"><span class="pi pi-exclamation-triangle" style="margin-right:5px;"></span>You must provide an answer to whether an allergy is present or not..</div>

                            <div *ngIf="bq.answers.allergyanswer.allergypresent==true">
                                <label for="bq{{bq.id}}" style="margin-top:20px;" class="font-medium">Please specify any allergy details below</label>
                                <input id="bq{{bq.id}}" type="text" [(ngModel)]="bq.answers.allergyanswer.allergytext" pInputText [ngClass]="{'ng-invalid ng-dirty': !mustanswerallergies[bq.listorder]}">
                            </div>
                            <div *ngIf="!mustanswerallergies[bq.listorder] && bq.answers.allergyanswer.allergypresent==true" class="text-danger" Style="margin-left:10px;margin-top:10px;"><span class="pi pi-exclamation-triangle" style="margin-right:5px;"></span>You must provide allergy details.</div>
                        </div>
                        
                        <div *ngIf="bq.questiontype=='REGISTER' && bq.answers != null">
                            <label for="bq{{bq.id}}" class="font-medium">{{bq.questiontext}}</label>

                            <!-- A register is the list of people on the booking. The name is always asked for; the rest
                                 of the fields are whichever ones the question was set up to include, and the last one
                                 carries the venue's own wording. -->
                            <div class="bqperson" *ngFor="let ibq of bq.answers.birthdayanswers; let pi = index">
                                <div class="bqperson-head">
                                    <span class="bqperson-title">{{ibq.name != null && ibq.name != '' ? ibq.name : 'Person ' + (pi + 1)}}</span>
                                    <button *ngIf="bq.answers.birthdayanswers.length > 1 && !bq.linkedtoparticipants" pButton type="button" class="p-button-danger p-button-text p-button-sm bqperson-delete" (click)="deleteBirthdayRow(bq, ibq.id)">
                                        <span class="pi pi-trash" style="margin-right:6px;"></span>
                                        <span>Delete</span>
                                    </button>
                                </div>

                                <div class="bqfields">
                                    <div class="bqfield bqfield--name">
                                        <label class="bqlabel" for="bqrname{{bq.id}}_{{ibq.id}}">Name</label>
                                        <input id="bqrname{{bq.id}}_{{ibq.id}}" type="text" placeholder="Name" [(ngModel)]="ibq.name" pInputText [ngClass]="{'ng-invalid ng-dirty': !mustanswerbirthdays[bq.listorder] && (ibq.name == '' || ibq.name == null)}">
                                    </div>

                                    <div class="bqfield bqfield--age" *ngIf="bq.showage">
                                        <label class="bqlabel">Age</label>
                                        <p-dropdown [options]="ageOptionsFor(bq)" [(ngModel)]="ibq.age" placeholder="Select age" optionLabel="name" optionValue="value" [ngClass]="{'ng-invalid ng-dirty': !mustanswerbirthdays[bq.listorder] && (ibq.age == '' || ibq.age == null)}"></p-dropdown>
                                    </div>

                                    <div class="bqfield bqfield--dob" *ngIf="bq.showdob">
                                        <label class="bqlabel">Date of Birth</label>
                                        <div class="bqdob">
                                            <p-dropdown class="bqdob-day" optionLabel="name" optionValue="value" [options]="caldays" [(ngModel)]="ibq.dobday" placeholder="--" [ngClass]="{'ng-invalid ng-dirty': !mustanswerbirthdays[bq.listorder] && (ibq.dobday == null || ibq.dobmonth == null || ibq.dobyear == null)}"></p-dropdown>
                                            <span class="bqdob-sep">/</span>
                                            <p-dropdown class="bqdob-month" optionLabel="name" optionValue="value" [options]="calmonths" [(ngModel)]="ibq.dobmonth" placeholder="--" [ngClass]="{'ng-invalid ng-dirty': !mustanswerbirthdays[bq.listorder] && (ibq.dobday == null || ibq.dobmonth == null || ibq.dobyear == null)}"></p-dropdown>
                                            <span class="bqdob-sep">/</span>
                                            <p-dropdown class="bqdob-year" optionLabel="name" optionValue="value" [options]="calyears" [(ngModel)]="ibq.dobyear" placeholder="----" [ngClass]="{'ng-invalid ng-dirty': !mustanswerbirthdays[bq.listorder] && (ibq.dobday == null || ibq.dobmonth == null || ibq.dobyear == null)}"></p-dropdown>
                                        </div>
                                    </div>

                                    <div class="bqfield bqfield--interests" *ngIf="bq.showinterests">
                                        <label class="bqlabel" for="bqrextra{{bq.id}}_{{ibq.id}}">{{bq.warningtext}}</label>
                                        <input id="bqrextra{{bq.id}}_{{ibq.id}}" type="text" [(ngModel)]="ibq.interests" pInputText [ngClass]="{'ng-invalid ng-dirty': !mustanswerbirthdays[bq.listorder] && (ibq.interests == '' || ibq.interests == null)}">
                                    </div>
                                </div>
                            </div>

                            <div *ngIf="!bq.linkedtoparticipants">
                                <button pButton type="button" class="p-button bqaddanother" (click)="addBirthdayRow(bq)">
                                    <span>Add another</span>
                                    <span class="pi pi-chevron-right" style="margin-left:8px;"></span>
                                </button>
                            </div>
                            <div *ngIf="!mustanswerbirthdays[bq.listorder]" class="text-danger" style="margin-top:10px;"><span class="pi pi-exclamation-triangle" style="margin-right:5px;"></span>You must provide all details.</div>
                        </div>

                        <div *ngIf="bq.questiontype=='AGE' && bq.answers != null">
                            <label for="bq{{bq.id}}" class="font-medium">{{bq.questiontext}}</label>
                            <p-inputNumber [showButtons]="true" buttonLayout="horizontal" [(ngModel)]="bq.answers.numberanswer" min="{{bq.minage}}" max="{{bq.maxage}}" spinnerMode="horizontal" [ngClass]="{'ng-invalid ng-dirty': !mustanswerage[bq.listorder]}"></p-inputNumber>
                            <div *ngIf="!mustanswerage[bq.listorder]" class="text-danger" Style="margin-left:10px;margin-top:10px;"><span class="pi pi-exclamation-triangle" style="margin-right:5px;"></span>You must provide age details.</div>
                        </div>
                        
                        <div *ngIf="bq.questiontype=='MULTICHOICESINGLE' && bq.answers != null">
                            <label for="bq{{bq.id}}" class="font-medium">{{bq.questiontext}}</label>
                            <div>
                                <p-dropdown [options]="bq.listitems" placeholder="Please select an option" optionLabel="listitemtext" [(ngModel)]="bq.answers.multichoicesingleanswer" [ngClass]="{'ng-invalid ng-dirty': !mustanswermultichoicesingleanswer[bq.listorder]}"></p-dropdown>
                            </div>
                            <div *ngIf="!mustanswermultichoicesingleanswer[bq.listorder]" class="text-danger" Style="margin-left:10px;margin-top:10px;"><span class="pi pi-exclamation-triangle" style="margin-right:5px;"></span>You must answer this question and choose an item.</div>
                        </div>
                        
                        <div *ngIf="bq.questiontype=='MULTICHOICEMULTIPLE' && bq.answers != null">
                            <label for="bq{{bq.id}}" class="font-medium">{{bq.questiontext}}</label>
                            <div>
                                <p-multiSelect [options]="bq.listitems" placeholder="Please select one or more options" optionLabel="listitemtext" [(ngModel)]="bq.answers.multichoicemultianswer" [ngClass]="{'ng-invalid ng-dirty': !mustanswermultichoicemultianswer[bq.listorder]}"></p-multiSelect>
                            </div>
                            <div *ngIf="!mustanswermultichoicemultianswer[bq.listorder]" class="text-danger" Style="margin-left:10px;margin-top:10px;"><span class="pi pi-exclamation-triangle" style="margin-right:5px;"></span>You must answer this question and choose one or more items.</div>
                        </div>
                        
                        <div *ngIf="bq.questiontype=='DATE' && bq.answers != null">
                            <label for="bq{{bq.id}}" class="font-medium">{{bq.questiontext}}</label>
                            <p-calendar [selectOtherMonths]="true" firstDayOfWeek="1" [(ngModel)]="bq.answers.dateanswer" dateFormat="dd/mm/yy" [showIcon]="true" [ngClass]="{'ng-invalid ng-dirty': !mustanswerdate[bq.listorder]}"></p-calendar>
                            <div *ngIf="!mustanswerdate[bq.listorder]" class="text-danger" Style="margin-left:10px;margin-top:10px;"><span class="pi pi-exclamation-triangle" style="margin-right:5px;"></span>You must answer this question and supply a date.</div>
                        </div>
                        
                        <div *ngIf="bq.questiontype=='NUMBER' && bq.answers != null">
                            <label for="bq{{bq.id}}" class="font-medium">{{bq.questiontext}}</label>
                            <p-inputNumber [showButtons]="true" buttonLayout="horizontal" [(ngModel)]="bq.answers.numberanswer" spinnerMode="horizontal" [ngClass]="{'ng-invalid ng-dirty': !mustanswernumber[bq.listorder]}"></p-inputNumber>
                            <div *ngIf="!mustanswernumber[bq.listorder]" class="text-danger" Style="margin-left:10px;margin-top:10px;"><span class="pi pi-exclamation-triangle" style="margin-right:5px;"></span>You must answer this question and supply a number.</div>
                        </div>
                        <hr style="margin-bottom:0px;margin-top:20px">
                    </div>
                </div>

                <div style="clear:both;">
                    <button pButton type="button" style="height: 50px; width: 155px;margin-top:20px;" class="p-button p-button" (click)="doneBookingQuestions()">
                        <span>Next</span>
                        <span class="pi pi-chevron-right" style="margin-left:8px;"></span>
                    </button> &nbsp;
                </div>
            </div>

        </p-accordionTab>

        <p-accordionTab *ngIf="PackageHasExtras" [(selected)]="extraSelected" [disabled]="extraActive">
            <p-header style="width:100%">
                <div style="width:100%">
                    <span class="pi pi-star" style="margin-right: 10px;"></span> {{ExtrasHeader}}
                </div>
            </p-header>

            <div class="col-12">
                <label class="font-medium">Please select any extras, you would like to add to your booking</label>

                <!-- One card per extra. The picture column only appears when at least one extra on offer
                     has a picture, so a package with none keeps a plain list, and when some do the rows
                     without one still line up behind an empty square. -->
                <div class="xtra-list">
                    <div *ngFor="let product of packageExtras; let i = index" class="xtra-card" [class.xtra-card--chosen]="product.qty > 0">
                        <div class="xtra-row">
                            <div *ngIf="extrasHaveImages" class="xtra-thumb">
                                <span class="pi pi-image xtra-thumb-empty"></span>
                                <img *ngIf="product.imageurl" [src]="product.imageurl" alt="" loading="lazy" (error)="$any($event.target).hidden = true">
                            </div>

                            <div class="xtra-info">
                                <div class="xtra-name">{{product.name}}</div>
                                <div *ngIf="showExtraDescription(product)" class="xtra-desc">{{product.description}}</div>
                                <div class="xtra-price">{{product.price | currency:CurrencySymbol}} each</div>
                            </div>

                            <div class="xtra-qty">
                                <p-inputNumber [(ngModel)]="product.qty" [showButtons]="true" max="{{product.max}}" min="{{product.min}}" buttonLayout="horizontal" spinnerMode="horizontal" (onInput)="sumExtras()" (onBlur)="sumExtras()"></p-inputNumber>
                                <div class="xtra-line" [class.xtra-line--zero]="!(product.qty > 0)">{{(product.qty * product.price) | currency:CurrencySymbol}}</div>
                            </div>
                        </div>

                        <div *ngIf="(product.question!='' && product.question != null) && product.qty > 0" class="xtra-question">
                            <label for="xtraanswer{{i}}">{{product.question}}</label>
                            <input id="xtraanswer{{i}}" type="text" [(ngModel)]="product.answer" pInputText [ngClass]="{'ng-invalid ng-dirty': !allQuestionsValid && (product.answer == null || product.answer == '')}">
                        </div>
                    </div>
                </div>
                    <div *ngIf="!allQuestionsValid" class="text-danger" Style="margin-left:10px; margin-top: 15px;"><span class="pi pi-exclamation-triangle" style="margin-right:5px;"></span>You must answer all questions.</div>
                    <div class="xtra-total"><span>Total</span><span>{{TotalExtras | currency:CurrencySymbol}}</span></div>
                <div style="clear:both;">
                    <button pButton type="button" style="height: 50px; width: 258px;margin-top:20px;" class="p-button p-button" (click)="doneExtras()">
                        <span>Next</span>
                        <span class="pi pi-chevron-right" style="margin-left:8px;"></span>
                    </button>
                </div> 
              </div>

        </p-accordionTab>

        <p-accordionTab  [(selected)]="customerSelected" [disabled]="customerActive">
            <p-header style="width:100%">
                <div style="width:100%">
                    <span class="pi pi-user" style="margin-right: 10px;"></span> {{CustomerHeader}}
                </div>
            </p-header>
            <div style="margin-bottom: 40px;">

                <div *ngIf="qbook!='true'">
                    <span style="width:282px;float:left; margin-bottom:20px;">
                        <div>
                            <input id="MembershipNumber" style="width:272px;" [(ngModel)]="MembershipID" placeholder="Enter Membership Number" pInputText>
                        </div>
                    </span>
                
                    <button pButton type="button" style="float:left;height: 50px; margin-left:10px;width:228px;" class="p-button-sm p-element p-ripple p-button p-component" (click)="addMembership()">
                        <span class="pi pi-user" style="margin-right:8px;"></span>
                        <span i18>Add Membership</span>
                    </button>
                </div>

                <div style="clear:both;"></div>
 
                <span *ngIf="qbook!='true'" class="p-input-icon-left ml-auto" style="margin-right:20px; float:left;"> 
                    <i class="pi pi-search"></i>
                    <input pInputText type="text" [(ngModel)]="searchCriteria" buttonLayout="horizontal" placeholder="Lastname/Mobile/Email" style="height: 50px;padding-left:33px;" />
                </span>
                
                <button *ngIf="qbook!='true'" pButton type="button" style="float:left;height: 50px;" class="p-button-sm p-element p-ripple p-button p-component" (click)="searchCustomer()">
                <span class="pi pi-search" style="margin-right:8px;"></span>
                <span i18>Search</span>
                </button>
                <!-- <p style="float: left;width: 376px;font-size: 15px;color: #ccc;margin-top: 10px;margin-left: 10px;">(Lastname/Mobile Number/Email)</p>
                 -->

                <button *ngIf="qbook!='true'" pButton type="button" style="float:left;height: 50px; margin-left:10px;" class="p-button-sm p-element p-ripple p-button p-component" (click)="doWalkin()">
                    <span class="pi pi-sign-in" style="margin-right:8px;"></span>
                    <span i18>Walk in</span>
                </button>

                <div style="clear:both;"></div>

                <div style="margin-top:20px;" class="surface-card p-4 shadow-2 border-round" *ngIf="customersResult">
                <p-table [value]="customersResult.data">
                  <ng-template pTemplate="header">
                    <tr style="color:Black;background-color:white;font-weight:bold;">
                      <th  width="1%">&nbsp;</th>
                      <th scope="col">Name</th>
                      <!-- <th scope="col">Address</th> -->
                      <th scope="col">Mobile</th>
                      <th scope="col">Email Address</th>
                      <th width="5%">&nbsp;</th>
                      <th width="5%">&nbsp;</th>
                    </tr>
                  </ng-template>
                  <ng-template pTemplate="body" let-data>
                    <tr onmouseover="this.originalstyle=this.style.backgroundColor;this.style.backgroundColor='#dddddd'" onmouseout="this.style.backgroundColor=this.originalstyle;" style="background-color: rgb(255, 255, 255); cursor: pointer;">
                        <td>
                            <button pButton pRipple type="button" class="p-button p-element p-button-danger" (click)="addselectedCustomer(data)">
                            <span class="pi pi-check" style="margin-right:8px;"></span>
                            Select</button>
                        </td>
                        <td *ngIf="data.hasmembership">
                            <button pButton pRipple type="button" class="p-button p-element p-button-secondary" style="width: 33px;height: 40px;background-color: gold;color: black;" (click)="showMemberships(data)">
                                <span class="pi pi-users" style="margin-left:-9px;"></span>
                            </button>
                        </td>
                        <td *ngIf="!data.hasmembership"></td>
                        <td>{{data.fullName}}</td>
                        <td>{{data.mobile}}</td>
                        <td>{{data.email}}</td>
                        <td>
                            <button pButton pRipple type="button" class="p-button p-element p-button-success" (click)="applyCustomer(data)">
                            <span class="pi pi-pencil" style="margin-right:8px;"></span>
                            Edit</button>
                        </td>
                    </tr>  
                    <div style="clear:both;"></div>
                    <tr id="div-{{data.id}}" style="display:none; width:100%;">
                        <td colspan="8" style="padding:0px;">
                            <p-table [value]="data.memberships">
                                <ng-template pTemplate="body" let-member>
                                    <tr>
                                        <td style="width:100px">&nbsp;</td>
                                        <td>{{member.salesid}}</td>
                                        <td>{{member.startdate | date}}</td>
                                        <td>{{member.enddate | date}}</td>
                                        <td style="text-align: right;">
                                            <button pButton pRipple type="button" class="p-button p-element p-button-danger" (click)="addselectedMember(member)">
                                            <span class="pi pi-check" style="margin-right:8px;"></span>
                                            Select</button>
                                        </td>
                                    </tr>
                                </ng-template>
                            </p-table>
                        </td>
                    </tr>
                  </ng-template>  
                </p-table>
                <button *ngIf="customersResult" style="margin-top:15px;" pButton pRipple type="button" class="p-button p-element p-button-success" (click)="addCustomer(data)">
                    <span class="pi pi-pencil" style="margin-right:8px;"></span>
                    Add Customer</button>
                </div>
            </div>

            <div *ngIf="ShowCustomerDetails" class="surface-card p-4 shadow-2 border-round">

                <div class="grid formgrid p-fluid">

                    <div *ngIf="IsToday() && qbook!='true'" class="field mb-4 col-12">
                        <p-selectButton id="exclusive" [style]="{'width': '100%', 'max-width' : '600px'}" [options]="stateOptions" [(ngModel)]="ProvideMinimalPersonalData" ></p-selectButton>
                    </div>

                    <div *ngIf="!IsToday() && qbook!='true'" class="field mb-4 col-12">
                        <p-selectButton id="exclusive" [style]="{'width': '100%', 'max-width' : '600px'}" [options]="stateOptionsMin" [(ngModel)]="ProvideMinimalPersonalData" ></p-selectButton>
                    </div>
                    
                    <div *ngIf="ProvideMinimalPersonalData == 'FULL' || ProvideMinimalPersonalData == 'LIMITED'" class="field mb-4 col-12" >
                        <label for="firstName" class="font-medium">First Name</label>
                        <input id="firstName" type="text" [(ngModel)]="firstName" pInputText autocomplete="given-name">
                    </div>
                    <div *ngIf="!firstNameValid" class="text-danger" Style="margin-left:10px; margin-top: -23px;"><span class="pi pi-exclamation-triangle" style="margin-right:5px;"></span>You must enter a first name.</div>

                    <div class="field mb-4 col-12">
                        <label for="lastname" class="font-medium">Last Name</label>
                        <input id="lastname" type="text" [(ngModel)]="lastName" pInputText autocomplete="family-name">
                    </div>
                    <div *ngIf="!lastNameValid" class="text-danger" Style="margin-left:10px; margin-top: -23px;"><span class="pi pi-exclamation-triangle" style="margin-right:5px;"></span>You must enter a last name.</div>

                    <div class="field mb-4 col-12" *ngIf="ProvideMinimalPersonalData == 'FULL'">
                        <label for="address1" class="font-medium">Address 1</label>
                        <input id="address1" type="text" [(ngModel)]="address1" pInputText autocomplete="address-line1">
                    </div>
                    <div *ngIf="!Address1Valid && ProvideMinimalPersonalData == 'FULL'" class="text-danger" Style="margin-left:10px; margin-top: -23px;"><span class="pi pi-exclamation-triangle" style="margin-right:5px;"></span>You must enter an address.</div>

                    <div class="field mb-4 col-12" *ngIf="ProvideMinimalPersonalData == 'FULL'">
                        <label for="address2" class="font-medium">Address 2</label>
                        <input id="address2" type="text" [(ngModel)]="address2" pInputText autocomplete="address-line2">
                    </div>
                
                    <div class="field mb-4 col-12" *ngIf="ProvideMinimalPersonalData == 'FULL'">
                        <label for="town" class="font-medium">Town / City</label>
                        <input id="town" type="text" [(ngModel)]="town" pInputText autocomplete="address-line3">
                    </div>
                    <div *ngIf="!TownValid && ProvideMinimalPersonalData == 'FULL'" class="text-danger" Style="margin-left:10px; margin-top: -23px;"><span class="pi pi-exclamation-triangle" style="margin-right:5px;"></span>You must enter a town/city.</div>

                    <div class="field mb-4 col-12" *ngIf="ProvideMinimalPersonalData == 'FULL'">
                        <label for="postcode" class="font-medium">Post Code</label>
                        <input id="postcode" type="text" [(ngModel)]="postCode" pInputText autocomplete="postal-code">
                    </div>
                    <div *ngIf="!PostCodeValid && ProvideMinimalPersonalData == 'FULL'" class="text-danger" Style="margin-left:10px; margin-top: -23px;"><span class="pi pi-exclamation-triangle" style="margin-right:5px;"></span>You must enter a postcode.</div>
                        
                    <div *ngIf="ProvideMinimalPersonalData == 'FULL' || ProvideMinimalPersonalData == 'LIMITED'" style="width:100%">
                        <div class="field mb-4 col-12">
                            <label for="email" class="font-medium">Email</label>
                            <input id="email" type="email" [(ngModel)]="email" pInputText autocomplete="email">
                        </div>
                     
                        <div *ngIf="!EmailValid" class="text-danger" Style="margin-left:10px; margin-top: -23px;"><span class="pi pi-exclamation-triangle" style="margin-right:5px;"></span>You must enter an email address.</div>
                        <div *ngIf="!EmailFormatValid" class="text-danger" Style="margin-left:10px; margin-top: -23px;"><span class="pi pi-exclamation-triangle" style="margin-right:5px;"></span>You must enter a valid email address.</div>
                    </div>
                    <div *ngIf="ProvideMinimalPersonalData == 'FULL' || ProvideMinimalPersonalData == 'LIMITED'" style="width:100%">
                        <div class="field mb-4 col-12">
                            <label for="mobile" class="font-medium">Mobile</label>
                            <input id="mobile" type="tel" pattern="^\+?\d{1,3}?[\s\-]?(\(?\d{1,4}\)?[\s\-]?)?[\d\s\-]{5,}$" [(ngModel)]="mobile" pInputText autocomplete="mobile">
                        </div>

                        <div *ngIf="!MobileValid" class="text-danger" Style="margin-left:10px; margin-top: -23px;"><span class="pi pi-exclamation-triangle" style="margin-right:5px;"></span>You must enter a mobile number.</div>
                        <div *ngIf="!MobileFormatValid" class="text-danger" Style="margin-left:10px; margin-top: -23px;"><span class="pi pi-exclamation-triangle" style="margin-right:5px;"></span>You must enter a valid mobile number.<div style="clear:both;"></div></div>
                    </div>
                    <div style="clear:both;width: 100%;height: 20px;"></div>
                    <button pButton type="button" style="height: 50px; width: 221px;margin-top:0px" class="p-button p-button" (click)="doneCustomer()">
                        <span>Add this Customer</span>
                        <span class="pi pi-chevron-right" style="margin-left:8px;"></span>
                    </button>

                </div>
            </div>


        </p-accordionTab>

        <p-accordionTab [(selected)]="notesSelected" [disabled]="notesActive">
            <p-header style="width:100%">
                <div style="width:100%">
                    <span class="pi pi-envelope" style="margin-right: 10px;"></span> Notes
                </div>
            </p-header>
            <div class="surface-card p-4 shadow-2 border-round">
                <div class="grid formgrid p-fluid">
                    <div class="field mb-4 col-12">
                        <label for="notesName" class="font-medium">Notes</label>
                        <textarea pInputTextarea [(ngModel)]="NewBooking.notes" id="notesName" type="text" ></textarea>
                    </div>
                </div>

                <div style="clear:both;">
                    <button pButton type="button" style="height: 50px; width: 155px;margin-top:20px;" class="p-button p-button" (click)="doneNotes()">
                        <span>Next</span>
                        <span class="pi pi-chevron-right" style="margin-left:8px;"></span>
                    </button> &nbsp;
                </div>
            </div>

        </p-accordionTab>

        <p-accordionTab [(selected)]="paymentSelected" [disabled]="paymentActive">
            <p-header style="width:100%">
                <div style="width:100%">
                    <span class="pi pi-money-bill" style="margin-right: 10px;"></span> {{PaymentHeader}}
                </div>
            </p-header>
            <div class="surface-card p-4 shadow-2 border-round">

                <div class="grid formgrid p-fluid">
                    <!-- A series is worth what its record says across every date. -->
                    <div *ngIf="isSeriesBooking && seriesRecord" style="font-weight:bold; font-size:20px; margin-bottom:20px;">
                        Value of Series ({{seriesBookings.length}} dates): {{seriesRecord.total | currency:CurrencySymbol}}
                        <span> &middot; Outstanding: {{seriesRecord.outstanding | currency:CurrencySymbol}}</span>
                    </div>
                    <div *ngIf="!(isSeriesBooking && seriesRecord)" style="font-weight:bold; font-size:20px; margin-bottom:20px;">
                        Value of Booking: {{(NewBooking.totaladmissions) |  currency:CurrencySymbol}} 
                        <span *ngIf="NewBooking.totaldiscounts > 0">(- Discount: {{NewBooking.totaldiscounts | currency:CurrencySymbol}})</span>
                        <span *ngIf="NewBooking.totalbookingfees> 0"> + Booking Fee: {{NewBooking.totalbookingfees | currency:CurrencySymbol}}</span>
                        <span *ngIf="NewBooking.totalextras> 0"> + Extras Value: {{NewBooking.totalextras | currency:CurrencySymbol}}</span>
                        <span *ngIf="NewBooking.totalupgrades> 0"> + Upgrades Value: {{NewBooking.totalupgrades | currency:CurrencySymbol}}</span>
                        <span> (Total Value: {{(NewBooking.total) | currency:CurrencySymbol}})</span>
                    </div>
                    
                    <div *ngIf="BookingPayments.length > 0" class="surface-card p-4 shadow-2 border-round" style="width:100%; margin-bottom: 20px;">
                        <label for="extras" class="font-medium">Payments already made</label>   
                        <div>
                            <p-table [value]="BookingPayments">
                                <ng-template pTemplate="header">
                                    <tr>
                                        <th></th>
                                        <th style="width:90%">Date</th>
                                        <th style="width:10%">Method</th>
                                        <th style="width:20%">Amount</th>
                                    </tr>
                                </ng-template>
                                <ng-template pTemplate="body" let-payment let-index>
                                    <tr>
                                        <td></td>
                                        <td>{{payment.paymentDate | date:'dd/MM/yyyy'}}</td>
                                        <td>{{payment.method}}</td>
                                        <td>{{(payment.amount) | currency:CurrencySymbol}}</td>
                                    </tr>
                                </ng-template>
                                <ng-template pTemplate="footer">
                                <tr>
                                    <td></td>
                                    <td>&nbsp;</td>
                                    <td>Total:</td>
                                    <td>{{totalPayments | currency:CurrencySymbol}}</td>
                                </tr>
                                </ng-template>
                            </p-table>
                        </div>
                        <div *ngIf="NewBooking.payments == null">
                            No payments have been made against this booking
                        </div>
                    </div>

                    <div class="field mb-4 col-12">
                        <label for="venueclosingname" class="font-medium">Payment Value</label>
                        <p-inputNumber [(ngModel)]="validPaymentAmount" mode="currency" currency="{{CurrencySymbol}}" locale="en-GB" [min]="0" [max]="9999"></p-inputNumber>
                    </div>

                    <!-- The series' own figures, across every date. -->
                    <div *ngIf="isSeriesBooking && seriesRecord" class="field mb-4 col-12" style="background:#f5f3ff;border:1px solid #c4b5fd;border-radius:10px;padding:12px;">
                        <b>Series value</b> : {{seriesRecord.total | currency:CurrencySymbol}}
                        &nbsp;&middot;&nbsp; <b>Paid</b> : {{seriesRecord.totalpayments | currency:CurrencySymbol}}
                        &nbsp;&middot;&nbsp; <b>Outstanding</b> : {{seriesRecord.outstanding | currency:CurrencySymbol}}
                    </div>
                    <div *ngIf="!paymentValueValid" class="text-danger" Style="margin-left:10px; margin-top: -23px;"><span class="pi pi-exclamation-triangle" style="margin-right:5px;"></span>You must enter a payment amount.</div>
                    <div *ngIf="!paymentValueExceededValid" class="text-danger" Style="margin-left:10px; margin-top: -23px;"><span class="pi pi-exclamation-triangle" style="margin-right:5px;"></span>You cannot pay more than the booking value.</div>
                    <div *ngIf="!paymentDepositValid" class="text-danger" Style="margin-left:10px; margin-top: -23px;"><span class="pi pi-exclamation-triangle" style="margin-right:5px;"></span>Your payment must be at least {{MinimumValidPayment | currency:CurrencySymbol}}.</div>

                    <!--<div class="field mb-4 col-12">
                        <label for="paymentType" class="font-medium">Payment Type</label>
                        <p-dropdown [options]="PaymentTypes" [(ngModel)]="selectedPayment" optionLabel="name" placeholder="Select a Type" [showClear]="true"></p-dropdown>
                    </div>
                    <div *ngIf="!paymentTypeValid" class="text-danger" Style="margin-left:10px; margin-top: -23px;"><span class="pi pi-exclamation-triangle" style="margin-right:5px;"></span>You must select a payment type.</div>-->
                </div>

                <div *ngIf="showDiscount" class="surface-card p-4 shadow-2 border-round" style="margin-bottom:20px;">
                    <div class="field mb-4 col-12">

                        <p-selectButton id="allergy" [style]="{'width': '100%', 'max-width' : '430px', 'margin-bottom' : '20px'}" [options]="stateOptionOpenDiscount" [(ngModel)]="openDiscount"></p-selectButton>

                        <div *ngIf="openDiscount">
                            <label for="discountCode" class="font-medium">Enter Discount Amount</label><br>
                            <p-inputNumber [(ngModel)]="chosenDiscountAmount" max="{{validPaymentAmount}}" min="0.01"  mode="currency" currency={{CurrencySymbol}} ></p-inputNumber>
                        </div>

                        <div *ngIf="!openDiscount">
                            <label for="discountCode" class="font-medium">Enter Discount Code</label><br>
                            <input id="discountCode" [(ngModel)]="discountCode" pInputText>
                        </div>
                    </div>
                    <button *ngIf="openDiscount" pButton type="button" style="height: 50px; width: 221px;margin-top:0px" class="p-button p-button" (click)="doneOpenDiscount()">
                        <span>Apply Discount</span>
                        <span class="pi pi-chevron-right" style="margin-left:8px;"></span>
                    </button>

                    <button *ngIf="!openDiscount" pButton type="button" style="height: 50px; width: 221px;margin-top:0px" class="p-button p-button" (click)="doneDiscount()">
                        <span>Apply Discount</span>
                        <span class="pi pi-chevron-right" style="margin-left:8px;"></span>
                    </button>
                </div>

                <div *ngIf="showVoucher" class="surface-card p-4 shadow-2 border-round" style="margin-bottom:20px;">
                    <div class="field mb-4 col-12" style="float:left;">
                        <label for="voucherCode" class="font-medium">Enter Gift Voucher</label><br>
                        <input id="voucherCode" [(ngModel)]="voucherCode" pInputText>
                        <br>
                        <label for="voucherPIN" class="font-medium">Enter PIN</label><br>
                        <input id="voucherPIN" [(ngModel)]="voucherpin" pInputText [maxlength]="4" type="password">
                        <div style="clear:both; width:100%"></div>
                    </div>
                    <div>
                        <button pButton type="button" style="height: 50px; width: 221px;margin-top:0px" class="p-button p-button" (click)="doneVoucher()">
                            <span>Apply</span>
                        </button>
                    </div>
                    <div style="clear:both; width:100%"></div>
                </div>   
                
                <button *ngFor="let p of PaymentTypes" [disabled]="paymentButtonLocked" pButton type="button" style="height: 50px; width: 221px;margin-top:0px;margin-right:15px;margin-bottom:10px;" class="p-button p-button" (click)="donePayment(p.id, p.name)">
                    <span *ngIf="p.name=='Cash' && CurrencySymbol=='GBP'" class="pi pi-pound" style="margin-right:8px;"></span>
                    <span *ngIf="p.name=='Cash' && CurrencySymbol=='USD'" class="pi pi-dollar" style="margin-right:8px;"></span>
                    <span *ngIf="p.name=='Cash' && CurrencySymbol=='EUR'" class="pi pi-euro" style="margin-right:8px;"></span>
                    <span *ngIf="p.name=='Cash' && CurrencySymbol=='AUD'" class="pi pi-dollar" style="margin-right:8px;"></span>
                    
                    <span *ngIf="p.name=='Card'" class="pi pi-credit-card" style="margin-right:8px;"></span>
                    <span *ngIf="p.name!='Cash' && p.name!='Card'" class="pi pi-money-bill" style="margin-right:8px;"></span>
                    <span>Pay With {{p.name}}</span>
                </button>
                <button *ngIf="!showDiscount" pButton type="button" style="height: 50px; width: 221px;margin-top:0px;margin-right:15px;margin-bottom:10px;" class="p-button p-button-success" (click)="displayDiscount()">
                    <span class="pi pi-arrow-circle-down" style="margin-right:8px;"></span>
                    <span>Enter Discount</span>
                </button>
                <button *ngIf="showDiscount" pButton type="button" style="height: 50px; width: 221px;margin-top:0px;margin-right:15px;margin-bottom:10px;" class="p-button p-button-success" (click)="displayDiscount()">
                    <span class="pi pi-arrow-circle-left" style="margin-right:8px;"></span>
                    <span>Hide Discount</span>
                </button>

                <button *ngIf="!showVoucher" pButton type="button" style="height: 50px; width: 221px;margin-top:0px;margin-right:15px;margin-bottom:10px;" class="p-button p-button-success" (click)="displayVoucher()">
                    <span class="pi pi-ticket" style="margin-right:8px;"></span>
                    <span>Enter Gift Voucher</span>
                </button>
                <button *ngIf="showVoucher" pButton type="button" style="height: 50px; width: 221px;margin-top:0px;margin-right:15px;margin-bottom:10px;" class="p-button p-button-success" (click)="displayVoucher()">
                    <span class="pi pi-ticket" style="margin-right:8px;"></span>
                    <span>Hide Gift Voucher</span>
                </button>

                <button *ngIf="NewBooking.discounts && !isSeriesBooking" pButton type="button" style="height: 50px; width: 221px;margin-top:0px;margin-right:15px;margin-bottom:10px;" class="p-button p-button-danger" (click)="removeDiscount()">
                    <span class="pi pi-arrow-circle-up" style="margin-right:8px;"></span>
                    <span>Remove Discount</span>
                </button>
                <button pButton type="button" style="height: 50px; width: 221px;margin-top:0px;margin-right:15px;margin-bottom:10px;" class="p-button p-button-danger" (click)="deferPayment()">
                    <span class="pi pi-clock" style="margin-right:8px;"></span>
                    <span>Defer Payment</span>
                </button>
                <br>
                <button *ngIf="!showDiscount && qbook!='true'" pButton type="button" style="height: 50px; width: 221px;margin-top:0px;margin-right:15px;margin-bottom:10px;" class="p-button p-button-warning" (click)="sendPaymentLink()">
                    <span class="pi pi-envelope" style="margin-right:8px;"></span>
                    <span>Send Payment Link</span>
                </button>
            </div>
        </p-accordionTab>
    </p-accordion>
    </div>
</div>
<div *ngIf="BookingComplete">
    <div class="p-3 flex flex-column flex-auto">
        <h3 style="margin-bottom:20px;" i18n>Booking Summary</h3>

        <div *ngIf="BookingSummary">

            <!-- A series lists every date with its own Sales ID below, the first of them being
                 this one, so showing it here as well only says it twice. The series reference
                 takes its place - it is the one that covers the whole booking. The condition
                 matches the one on that list, so a series with a single date still shows the
                 Sales ID. -->
            <div *ngIf="!(BookingSummary.seriesdates && BookingSummary.seriesdates.length > 1)" style="width:100%; margin-bottom: 15px;">
                <span class="pi pi-calendar" style="margin-right: 10px;"></span><b>Sales ID</b> : {{BookingSummary.bookingIdHR}}
            </div>

            <div *ngIf="BookingSummary.seriesdates && BookingSummary.seriesdates.length > 1 && BookingSummary.seriesidhr" style="width:100%; margin-bottom: 15px;">
                <span class="pi pi-sync" style="margin-right: 10px;"></span><b>Series Reference</b> : {{BookingSummary.seriesidhr}}
            </div>

            <div style="width:100%; margin-bottom: 15px;">
                <span class="pi pi-calendar" style="margin-right: 10px;"></span>
                <b *ngIf="!BookingSummary.seriesdates">Start Date/Time</b>
                <b *ngIf="BookingSummary.seriesdates">First Date/Time</b> : {{BookingSummary.startTime | date:'dd/MM/yyyy HH:mm' : 'UTC'}}
            </div>

            <!-- A repeatable package makes one booking per date, each with its own Sales ID. -->
            <div *ngIf="BookingSummary.seriesdates && BookingSummary.seriesdates.length > 1" style="width:100%; margin-bottom: 15px;">
                <span class="pi pi-sync" style="margin-right: 10px;"></span>
                <b>All Dates</b> : {{BookingSummary.seriesdates.length}} bookings in this series

                <div style="margin-top:5px; margin-bottom:10px;">
                    <table [cellPadding]="3">
                        <tr style="border-bottom: 1px solid #dddddd" *ngFor="let seriesitem of BookingSummary.seriesdates">
                            <td>&nbsp;</td>
                            <td>
                                <b>{{seriesitem.startTime | date:'EEE dd/MM/yyyy' : 'UTC'}}</b>
                            </td>
                            <td>
                                {{seriesitem.startTime | date:'HH:mm' : 'UTC'}}
                            </td>
                            <td>
                                {{seriesitem.bookingIdHR}}
                            </td>
                            <td style="text-align: right;">
                                {{seriesitem.total | currency:CurrencySymbol}}
                            </td>
                        </tr>
                    </table>
                </div>
            </div>

            <div style="width:100%; margin-bottom: 15px;">
                <span class="pi pi-user" style="margin-right: 10px;"></span>
                <b>Customer</b> : {{BookingSummary.customerAddress}}
            </div>
            <div style="width:100%; margin-bottom: 15px;">
                <span class="pi pi-box" style="margin-right: 10px;"></span>
                <b>Package</b> : {{BookingSummary.packageName}}
            </div>
            <div style="width:100%; margin-bottom: 15px;">
                <span class="pi pi-users" style="margin-right: 10px;"></span>
                <b>Admissions</b> : {{BookingSummary.admissions}}
            </div>
            
            <div *ngIf="BookingSummary.upgrade != ''" style="width:100%; margin-bottom: 15px;">
                <span class="pi pi-arrow-up" style="margin-right: 10px;"></span>
                <b>Upgrade</b> : {{BookingSummary.upgradetext}}
            </div>

            <div *ngIf="BookingSummary.upgrade != ''" style="width:100%; margin-bottom: 15px;">
                <span class="pi pi-arrow-circle-up" style="margin-right: 10px;"></span>
                <b>Add-Ons</b> : {{BookingSummary.addontext}}
            </div>

            <div *ngIf="BookingSummary.extras != ''" style="width:100%; margin-bottom: 15px;">
                <span class="pi pi-star" style="margin-right: 10px;"></span>
                <b>Extras</b> : {{BookingSummary.extras}}
            </div>

            <div *ngIf="BookingSummary.totalbookingfees > 0" style="width:100%; margin-bottom: 15px;">
                <span class="pi pi-pound" style="margin-right: 10px;"></span>
                <b>Booking Fee</b> : {{BookingSummary.totalbookingfees | currency:CurrencySymbol }}
            </div>

            <div style="width:100%; margin-bottom: 15px;">
                <span class="pi pi-pound" style="margin-right: 10px;"></span>
                <b *ngIf="!BookingSummary.seriesdates">Sales Value</b>
                <b *ngIf="BookingSummary.seriesdates">Sales Value (first date)</b> : {{BookingSummary.total | currency:CurrencySymbol }}
            </div>

            <div *ngIf="BookingSummary.seriesdates && BookingSummary.seriesdates.length > 1" style="width:100%; margin-bottom: 15px;">
                <span class="pi pi-pound" style="margin-right: 10px;"></span>
                <b>Sales Value (all dates)</b> : {{BookingSummary.seriestotal | currency:CurrencySymbol }}
            </div>

            <div *ngIf="BookingSummary.totaldiscounts > 0" style="width:100%; margin-bottom: 15px;">
                <span class="pi pi-pound" style="margin-right: 10px;"></span>
                <b>Discounts</b> : {{BookingSummary.totaldiscounts | currency:CurrencySymbol }}
            </div>

            <!-- A series is paid as a whole, so its record's figures replace the first date's. -->
            <ng-container *ngIf="BookingSummary.seriesoutstanding != null">
                <div style="width:100%; margin-bottom: 15px;">
                    <span class="pi pi-pound" style="margin-right: 10px;"></span>
                    <b>Paid (all dates)</b> : {{BookingSummary.seriespaid | currency:CurrencySymbol }}
                </div>
                <div style="width:100%; margin-bottom: 15px;">
                    <span class="pi pi-pound" style="margin-right: 10px;"></span>
                    <b>Outstanding (all dates)</b> :
                    <span [ngStyle]="BookingSummary.seriesoutstanding > 0 ? {'color': 'red', 'font-weight': 'bold'} : {}">{{BookingSummary.seriesoutstanding | currency:CurrencySymbol }}</span>
                </div>
            </ng-container>

            <ng-container *ngIf="BookingSummary.seriesoutstanding == null">
            <div *ngIf="BookingSummary.outstanding > 0" style="width:100%; margin-bottom: 15px;">
                <span class="pi pi-pound" style="margin-right: 10px;"></span>
                <b>Paid</b> : <span>{{BookingSummary.paid | currency:CurrencySymbol }}</span>
            </div>
            <div *ngIf="BookingSummary.outstanding <= 0" style="width:100%; margin-bottom: 15px;">
                <span class="pi pi-pound" style="margin-right: 10px;"></span>
                <b>Paid</b> : {{BookingSummary.paid | currency:CurrencySymbol }}
            </div>

            <div *ngIf="BookingSummary.outstanding > 0" style="width:100%; margin-bottom: 15px;">
                <span class="pi pi-pound" style="margin-right: 10px;"></span>
                <b>Outstanding</b> : <span style="color: red; font-weight: bold;">{{BookingSummary.outstanding | currency:CurrencySymbol }}</span>
            </div>
            <div *ngIf="BookingSummary.outstanding <= 0" style="width:100%; margin-bottom: 15px;">
                <span class="pi pi-pound" style="margin-right: 10px;"></span>
                <b>Outstanding</b> : {{BookingSummary.outstanding | currency:CurrencySymbol }}
            </div>
            </ng-container>

            <div style="width:100%; margin-bottom: 15px;">
            
            <div *ngIf="SummaryItinerary">
                <span class="pi pi-list" style="margin-right: 10px;"></span><b>Itinerary</b>:

                <div style="margin-top:5px; margin-bottom:10px;">
                    <table [cellPadding]="3" >

                        <tr style="border-bottom: 1px solid #dddddd" *ngFor="let itin of (NewBooking.itineraryEX)">
                            <td>&nbsp;</td>
                            <td>
                                <b>{{itin.resource}}</b>
                            </td>
                            <td>
                                {{itin.starttime}}
                            </td>
                            <td >
                                {{itin.people}}&nbsp;people
                            </td>

                        </tr>

                        <tr style="border-bottom: 1px solid #dddddd">
                            <td>&nbsp;</td>
                            <td>
                                <b>End:</b>
                            </td>
                            <td>
                                {{addMs(BookingSummary.endTime, 1)| date:'HH:mm' : 'UTC'}}
                            </td>
                            <td>&nbsp;</td>
                        </tr>
                    </table>
                </div>
            </div>


            <div style="width:100%; margin-bottom: 15px;">
                <span class="pi pi-envelope" style="margin-right: 10px;"></span><b>Email</b> : {{BookingSummary.customerEmail}}
                <button pButton type="button" style="height: 25px; margin-right: 5px;width: 25px; float:right;" class="p-button-sm p-element p-ripple p-button p-component" (click)="sendanemail(bookingFromClick.bookingdata.bookingid)">
                    <span class="pi pi-envelope" style="margin-left: -8px; font-size: 15px;"></span>
                </button>
            </div>
            <div style="width:100%; margin-bottom: 15px;">
                <span class="pi pi-mobile" style="margin-right: 10px;"></span><b>Mobile</b> : {{BookingSummary.customerMobile}}
                <button pButton type="button" style="height: 25px; margin-right: 5px;width: 25px; float:right;" class="p-button-sm p-element p-ripple p-button p-component" (click)="makeacall(bookingFromClick.bookingdata.bookingid)">
                    <span class="pi pi-mobile" style="margin-left: -8px; font-size: 15px;"></span>
                </button>
            </div>

            <div style="width:100%; margin-bottom: 15px;">
                <span class="pi pi-file" style="margin-right: 10px;"></span><b>Notes</b> : {{BookingSummary.notes}}
            </div>

        </div>
    </div>

<!--<div class="surface-card p-4 shadow-2 border-round">-->
            <div style="margin-top: 25px;">
                <button *ngIf="BookingSummary.customerEmail != ''" pButton pRipple type="button" class="p-button-success p-element p-button w-auto mt-3" (click)="sendEmailConfirmation()">
                <span class="pi pi-envelope" style="margin-right:8px;"></span>
                Send Confirmation Email</button>
                &nbsp;
                <button *ngIf="BookingSummary.customerMobile != ''" disabled="true" pButton pRipple type="button" class="p-button-success p-element p-button w-auto mt-3" (click)="sendSMSConfirmation()">
                <span class="pi pi-mobile" style="margin-right:8px;"></span>
                Send Confirmation Text</button>
                &nbsp;
                <button pButton pRipple type="button" class="p-button-info p-element p-button w-auto mt-3" (click)="printConfirmation()">
                <span class="pi pi-print" style="margin-right:8px;"></span>
                Print Confirmation</button>
                &nbsp;
                <button *ngIf="qbook!='true'" pButton pRipple type="button" class="p-button p-element p-button w-auto mt-3" (click)="returnHome()">
                <span class="pi pi-calendar-plus" style="margin-right:8px;"></span>
                Make Another Booking</button>

                <button *ngIf="qbook=='true'" pButton pRipple type="button" class="p-button p-element p-button w-auto mt-3" (click)="returnQHome()">
                <span class="pi pi-calendar-plus" style="margin-right:8px;"></span>
                Make Another Quick Booking</button>

                &nbsp;
                <button *ngIf="Checkfortoday() && qbook!='true'" pButton pRipple type="button" class="p-button p-button-success p-element p-button w-auto mt-3" (click)="admitall()">
                <span class="pi pi-sign-in" style="margin-right:8px;"></span>
                Admit this Booking</button>

                <button *ngIf="Checkfortoday() && qbook=='true'" pButton pRipple type="button" class="p-button p-button-success p-element p-button w-auto mt-3" (click)="admitAndReturn()">
                <span class="pi pi-sign-in" style="margin-right:8px;"></span>
                Admit this Booking</button>
            </div>

    </div>
</div>

